import * as React from "react";

export const SpinnerStroke = ({stroke='#33415088'}) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        className="spinner lds-rolling"
        style={{
            shapeRendering: "auto",
            animationPlayState: "running",
            animationDelay: "0s",
            background: "none",
            strokeLinecap: "round"
        }}
    >
        <circle cx="50" cy="50" fill="none"
            stroke={stroke}
            strokeWidth="5"
            r="40"
            strokeDasharray="188.49555921538757 64.83185307179586"
            style={{
            animationPlayState: "running",
            animationDelay: "0s"
            }}
            transform="rotate(18.0342 50 50)">
            <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
            dur="2s"
            begin="0s"
            repeatCount="indefinite"
            style={{
                animationPlayState: "running",
                animationDelay: "0s"
            }}
            />
        </circle>
    </svg>

)